import { Component, OnInit } from '@angular/core';
import { ExcelDataProvider } from 'src/app/_Core/_Providers/excel.provider';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  standalone: false,
  selector: 'app-companies-rfid-bulkupload',
  templateUrl: './companies-rfid-bulkupload.component.html',
  styleUrls: ['./companies-rfid-bulkupload.component.scss']
})
export class CompaniesRfidBulkuploadComponent implements OnInit {

  success: boolean;
  templateUrl: any;

  constructor(
    private router: Router,
    private excelProvider: ExcelDataProvider,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
  ) { }

  ngOnInit(): void {
    this.templateUrl = '';
    this.activatedRoute.queryParams.subscribe((res) => {
      this.success = res?.sucess ? res?.sucess : false;
    });
  }

  handleFileSelect(evt) {
    var files = evt.target.files;
    var xl2json = new this.excelProvider.ExcelToJSON();
    xl2json
      .parseExcel(files[0])
      .then((data) => {
        // this.prepareTableData(JSON.parse(data));
        this.dataService.setExcelData(data);
        this.router.navigateByUrl('companies/companies-list/rfid-bulk-upload-preview');
      })
      .catch((err) => {
        console.log('Failed to read excel ', err);
      });
  }

}
